<script setup lang="ts">
import CreditSafeValue from '@/components/common/ui/CreditSafeValue.vue'
import { usePartnerStore } from '@/stores/usePartnerStore'
import { storeToRefs } from 'pinia'
import { computed, onMounted, watch } from 'vue'
import LoaderCenter from '@/components/common/feedback/LoaderCenter.vue'

const partnerStore = usePartnerStore()
const { loading, partnerForCreditSafe, partner } = storeToRefs(partnerStore)

const props = defineProps({
  partnerId: {
    type: Number,
    required: false,
  },
})

const score = computed(
  () => partnerForCreditSafe.value?.creditSafeValue || partner.value?.creditSafeValue || '',
)
const scoreText = computed(
  () => partnerForCreditSafe.value?.creditSafeRiskText || partner.value?.creditSafeRiskText || '',
)

watch(
  props,
  () => {
    if (props.partnerId) partnerStore.searchCreditSafeValuesByPartnerId(props.partnerId)
  },
  { immediate: true, deep: true },
)

onMounted(() => {
  partnerForCreditSafe.value = null
  if (props.partnerId) partnerStore.searchCreditSafeValuesByPartnerId(props.partnerId)
})
</script>

<template>
  <div class="flex gap-2 mt-auto justify-start" v-if="score && !loading">
    <p class="self-center">Confiance</p>
    <div class="tooltip" :data-tip="scoreText">
      <credit-safe-value class="text-3xl px-3" :credit-safe-value="score"></credit-safe-value>
    </div>
  </div>
  <loader-center v-else-if="loading" class="mt-auto" />
  <div v-else />
</template>
